
import { IGroupItem } from '@src/framework/frame/components/tool-bar/common/group-disable';
import { ToolbarType } from '@src/js/constant';
import { IDoubleToolBarItem, IMenuDataWorkerManager, IMenuItemDataWorker, IMenuItemValueWorker } from './interface';

// 从之前 src/js/manager/menu-data-worker 迁移过来，目前好像只有格式刷有用到，quick-setting 中格式刷按钮的动态设置和这个有关，其他不清楚
export default class MenuDataWorkerManager implements IMenuDataWorkerManager  {
    private itemValueWorkers: Array<IMenuItemValueWorker> = [];
    private itemDataworkers: any = {};
    /**
     * 添加工具栏或菜单Item Value的处理器,Value影响Item的显示状态，例如按下状态。
     */
    public addItemValueWorker(worker: IMenuItemValueWorker) {
        this.itemValueWorkers.push(worker);
    }
    /**
     * 删除工具栏或菜单Item Value的处理器
     * worker: IMenuItemValueWorker
     */
    public removeItemValueWorker(worker: IMenuItemValueWorker) {
        const index = this.itemValueWorkers.indexOf(worker);
        if (index > -1) {
            this.itemValueWorkers.splice(index, 1);
        }
    }
    /**
     * 添加工具栏或菜单Item Data的处理器，Data影响Item的显示图标，tips文字等。
     */
    public addItemDataWorker(worker: IMenuItemDataWorker) {
        if (worker) {
            this.itemDataworkers[worker.id] = worker;
        }
    }
    /**
     * removeWorker
     * worker: IMenuItemValueWorker
     */
    public removeItemDataWorker(itemId: string) {
        if (itemId) {
            delete this.itemDataworkers[itemId];
        }
    }
    /**
     * 工具栏或菜单Item Value的处理器，Value影响Item的显示状态，例如按下状态
     */
    public processMenuItemValues(itemValues: any, type: any): any {
        let values = itemValues;
        for (const worker of this.itemValueWorkers) {
            values = worker.processMenuItemValues(values, type);
        }
        return values;
    }

    /**
     * 工具栏或菜单Item Data的处理器，Data影响Item的显示图标，tips文字等。
     */
    public processItemData(items: Array<any>, type: string, toolbarMode: string | null) {
        for (const item of items) {
            if (item.id) {
                this.processDetailItemData(item, type);
            }
            // 初始加载工具栏时toolbarModel为null
            if (!toolbarMode || toolbarMode === ToolbarType.DOUBLE_TOOLBAR) {
                this.processDoubleToolItemData(item, type);
            }
        }
    }

    private processDetailItemData(item: IGroupItem, type: string) {
        const worker: IMenuItemDataWorker = this.itemDataworkers[item.id] as IMenuItemDataWorker;
        worker?.processMenuItemData(item, type);
    }

    /**
     * 处理工具栏双栏的Item
     */
    private processDoubleToolItemData(item: IDoubleToolBarItem, type: string) {
        const doubleToolbarItemTypeList = ['big', 'bottom', 'top'];
        doubleToolbarItemTypeList.forEach((doubleType) => {
            if (Array.isArray(item[doubleType])) {
                item[doubleType].forEach((doubleToolbarItem) => {
                    this.processDetailItemData(doubleToolbarItem, type);
                });
            }
        });
    }
}
